<template>
    <div class="vacature bg-gray-100 p-6 rounded-lg shadow-md">
      <!-- Titel -->
      <h2 class="text-2xl font-bold text-sky-900 mb-2">{{ title }}</h2>
      <!-- Onderschrift -->
      <p class="text-gray-600 mb-4">{{ subtitle }}</p>
      <!-- Knoppen voor contact -->
      <div class="flex space-x-4">
        <button
          class="bg-sky-500 hover:bg-sky-600 text-white py-2 px-4 rounded shadow-md flex items-center space-x-2 transition"
          @click="contactPhone"
        >
          <i class="fas fa-phone-alt"></i>
          <span>Bellen</span>
        </button>
        <button
          class="bg-sky-400 hover:bg-sky-500 text-white py-2 px-4 rounded shadow-md flex items-center space-x-2 transition"
          @click="contactEmail"
        >
          <i class="fas fa-envelope"></i>
          <span>Email</span>
        </button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "VacatureComponent",
    props: {
      title: { type: String, required: true },
      subtitle: { type: String, required: true },
    },
    methods: {
      contactPhone() {
        window.open("tel:+31135713106", "_self");
      },
      contactEmail() {
        window.open("mailto:info@visspecialistvanwijk.nl", "_self");
      },
    },
  };
  </script>
  
  <style scoped>
  /* Voeg styling naar wens toe */
  </style>
  